import { useEffect } from "react";
import { useDispatch } from "react-redux";
import CachedItem, { LoadCachedItem } from "../config/cache";
import { setToken, setAccount } from "../reducer/userReducer";

export default function useLoadCache() {
  const dispatch = useDispatch();

  const loadToken = () => {
    const data = LoadCachedItem(CachedItem.token, true);
    data && dispatch(setToken(data));
  };

  const loadAccount = () => {
    const account = LoadCachedItem(CachedItem.account, true);
    if (account) {
      dispatch(setAccount(account));
    }
  };

  useEffect(() => {
    loadToken();
    loadAccount();
  }, []);

  return undefined;
}
